import React from 'react';
import './AboutPage.css';

const AboutPage = () => {

  return (
    <div className="about-page">
      <div className="about-hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/elektrik9.jpeg)` }}>
        <div className="about-hero-bg" aria-hidden="true" />
        <div className="container about-hero-inner">
          <div className="about-hero-logo-wrap">
            <img src="/logo.png" alt="Kalfa Elektrik Elektronik" className="about-hero-logo" />
          </div>
          <h1 className="about-hero-title">Kalfa Elektrik Elektronik</h1>
          <p className="about-hero-subtitle">
            Profesyonel elektrik ve elektronik çözümlerinde güvenilir ortağınız
          </p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Hikayemiz</h2>
              <div className="section-content">
                <p>
                  Kalfa Elektrik Elektronik olarak, elektrik ve elektronik sektöründe yılların verdiği deneyim ve 
                  bilgi birikimiyle hizmet vermekteyiz. İstanbul'da bulunan modern tesislerimizde, 
                  en son teknoloji ile donatılmış makinelerimizle kaliteli üretim yapmaktayız.
                </p>
                <p>
                  Müşteri memnuniyetini ön planda tutan anlayışımızla, sektörde güvenilir bir marka 
                  haline geldik. Küçük işletmelerden büyük zincirlere kadar geniş bir müşteri 
                  portföyüne sahibiz ve her bir müşterimize özel çözümler sunmaktayız.
                </p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="mission-vision-container">
              <div className="mission-vision-item">
                <h2 className="section-title">Misyonumuz</h2>
                <div className="section-content">
                  <p>
                    Misyonumuz, güvenli ve kaliteli elektrik ve elektronik çözümleri sunarak işletmelerin 
                    ve bireylerin ihtiyaçlarını karşılamak ve modern yaşam standartlarını yükseltmektir. 
                    Tüm projelerimizde güvenlik standartlarına uygun malzemeler kullanarak, güvenilir 
                    ve uzun ömürlü sistemler kuruyoruz.
                  </p>
                  <p>
                    Müşterilerimize en kaliteli elektrik ve elektronik hizmetleri, en uygun fiyatlarla ve 
                    en hızlı şekilde ulaştırmak temel hedefimizdir. Bu doğrultuda sürekli kendimizi geliştiriyor, 
                    teknolojiye yatırım yapıyor ve müşteri memnuniyetini artırmak için çalışıyoruz.
                  </p>
                </div>
              </div>
              <div className="mission-vision-item">
                <h2 className="section-title">Vizyonumuz</h2>
                <div className="section-content">
                  <p>
                    Vizyonumuz, Türkiye'nin önde gelen elektrik ve elektronik hizmet sağlayıcılarından biri 
                    olmak ve uluslararası pazarlarda da yer almak. Sektörde yenilikçi çözümler sunarak, 
                    müşterilerimize değer katmak ve sürdürülebilir büyüme sağlamak.
                  </p>
                  <p>
                    Gelecekte daha geniş bir hizmet yelpazesi sunarak, elektrik ve elektronik sektöründe 
                    kapsamlı bir çözüm ortağı olmayı hedefliyoruz. Ar-Ge çalışmalarımıza devam ederek, 
                    akıllı sistemler ve yenilikçi teknolojiler geliştirmeye odaklanıyoruz.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Değerlerimiz</h2>
              <div className="values-grid">
              <div className="value-card">
                <h3>Kalite</h3>
                <p>
                  Üretim süreçlerimizde en yüksek kalite standartlarını uyguluyor, 
                  her ürünümüzü titizlikle kontrol ediyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Güvenilirlik</h3>
                <p>
                  Müşterilerimize verdiğimiz sözleri tutuyor, zamanında teslimat 
                  ve kaliteli hizmet sunuyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Güvenlik</h3>
                <p>
                  Tüm projelerimizde güvenlik standartlarına uygun çalışarak, 
                  güvenli ve güvenilir sistemler kuruyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Müşteri Odaklılık</h3>
                <p>
                  Müşterilerimizin ihtiyaçlarını anlayarak, onlara özel çözümler 
                  geliştiriyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Yenilikçilik</h3>
                <p>
                  Sektördeki gelişmeleri takip ederek, yenilikçi ürün ve hizmetler 
                  sunuyoruz.
                </p>
              </div>
              <div className="value-card">
                <h3>Uygun Fiyat</h3>
                <p>
                  Kaliteli ürünleri, rekabetçi fiyatlarla müşterilerimize 
                  sunuyoruz.
                </p>
              </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Hizmet Sürecimiz</h2>
              <div className="section-content">
                <p>
                  Profesyonel ekibimiz ve en son teknoloji ekipmanlarımızla elektrik ve elektronik 
                  projelerinizi gerçekleştirmekteyiz. Hizmet sürecimiz, proje planlamasından teslimata 
                  kadar her aşamada kalite kontrolünden geçmektedir.
                </p>
              </div>
              <div className="process-steps">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <h3>Proje Planlama</h3>
                  <p>
                    Müşteri ihtiyaçları analiz edilerek, detaylı proje planlaması yapılır.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <h3>Malzeme Seçimi</h3>
                  <p>
                    Güvenlik standartlarına uygun, kaliteli malzemeler seçilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <h3>Kurulum</h3>
                  <p>
                    Uzman ekibimizle, güvenli ve profesyonel kurulum gerçekleştirilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <h3>Test ve Kontrol</h3>
                  <p>
                    Sistem, uzman ekibimiz tarafından titizlikle test edilir ve kontrol edilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">5</div>
                  <h3>Dokümantasyon</h3>
                  <p>
                    Proje dokümantasyonu hazırlanarak, müşteriye teslim edilir.
                  </p>
                </div>
                <div className="process-step">
                  <div className="step-number">6</div>
                  <h3>Bakım Desteği</h3>
                  <p>
                    Müşterilerimize sürekli bakım ve teknik destek hizmeti sunulur.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Neden Bizi Seçmelisiniz?</h2>
              <div className="why-choose-grid">
              <div className="why-choose-card">
                <h3>Geniş Hizmet Yelpazesi</h3>
                <p>
                  Elektrik tesisatından akıllı ev sistemlerine kadar geniş bir hizmet yelpazesi sunuyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Özel Çözümler</h3>
                <p>
                  Her projeye özel çözümler geliştirerek, ihtiyaçlarınıza en uygun sistemleri kuruyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Hızlı Hizmet</h3>
                <p>
                  Deneyimli ekibimiz sayesinde, projelerinizi zamanında ve hızlıca tamamlıyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Uygun Fiyat</h3>
                <p>
                  Kaliteli hizmetleri, rekabetçi fiyatlarla sunuyoruz.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>7/24 Destek</h3>
                <p>
                  7/24 teknik destek ve acil müdahale hizmeti ile yanınızdayız.
                </p>
              </div>
              <div className="why-choose-card">
                <h3>Güvenilir Sistemler</h3>
                <p>
                  Güvenlik standartlarına uygun, güvenilir ve uzun ömürlü sistemler kuruyoruz.
                </p>
              </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
